import { render } from "./SearchCustomerAddressModal.vue?vue&type=template&id=5cefdac0"
import script from "./SearchCustomerAddressModal.vue?vue&type=script&lang=js"
export * from "./SearchCustomerAddressModal.vue?vue&type=script&lang=js"
script.render = render

export default script